<template>
  <div class="ticket-users-title-container">
    <div v-if="ticket && ticket.assignedEmployees && !ticket.unreadMessages" class="ticket-users">
      <div class="user-avatar-stacked-container">
        <user-avatar
          :name="ticket.client.name"
          :online="ticket.client.online"
          :avatar="ticket.client.avatar"
          :size="target === 'tickets' ? '24px' : '36px'"
        />
        <!-- :online="user.online" -->
        <user-avatar
          v-for="(user, index) in ticket.assignedEmployees"
          :key="index"
          :name="user.name"
          :online="false"
          :avatar="user.avatar"
          :size="target === 'tickets' ? '24px' : '36px'"
        />
      </div>
    </div>
    <div v-if="ticket && ticket.unreadMessages" class="ticket-unread-messages-counter">
      {{ ticket.unreadMessages }}
    </div>
    <div class="ticket-title" :class="[{ 'small-title': target && target === 'tickets' }]">
      <span>
        {{ getTitle }}
      </span>
    </div>
  </div>
</template>

<script>
import UserAvatar from '~/marketplace-front-core/components/shared/UserAvatar'

export default {
  name: 'NewMessengerConversationHeader',
  components: { UserAvatar },
  props: {
    ticket: {
      type: Object,
      default: null
    },
    target: {
      type: String,
      default: ''
    }
  },
  computed: {
    getTitle () {
      // if (this.ticket.title) {
      //   return this.ticket.title
      // }
      let title = this.ticket.client.name
      this.ticket.assignedEmployees.forEach((user) => {
        title = title.concat(', ', user.name)
      })

      return title
    }
  }
}
</script>

<style lang="scss" scoped>
.text-semibold {
  font-weight: 600 !important;
}
.ticket-users-title-container {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;

  .ticket-users {
    display: flex;

    .user-avatar-stacked-container {
      display: flex;
    }
  }

  .ticket-unread-messages-counter {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    background-color: #eeeeee;
    color: $text_color;
    border-radius: 13px;
    font-size: 12px;
  }

  .ticket-title {
    flex-shrink: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;

    &.small-title {
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
